import sortBy from "lodash/sortBy";

export const DEFAULT_SQUARE_FOOTAGE_TYPES = [
  ["standard_square_footage", "Standard Square Footage"],
];

export const getSortedSquareFootageTypes = (squareFootageTypes = []) => {
  if (!squareFootageTypes) return [];
  return sortBy(squareFootageTypes, type => type.sortOrder || 0);
};

export const getActiveSortedSquareFootageTypes = (squareFootageTypes = []) => {
  if (!squareFootageTypes) return [];
  return getSortedSquareFootageTypes(squareFootageTypes.filter(type => type.isActive));
};

export const getSquareFootageTypeOptions = (squareFootageTypes = []) => {
  const activeTypes = getActiveSortedSquareFootageTypes(squareFootageTypes)
    .filter(type => type.id)
    .map(type => [type.id, type.name]);

  return activeTypes.length > 0 ? activeTypes : DEFAULT_SQUARE_FOOTAGE_TYPES;
};
